import { render, staticRenderFns } from "./AdvancedFormView.vue?vue&type=template&id=bf2708cc&"
import script from "./AdvancedFormView.vue?vue&type=script&lang=ts&"
export * from "./AdvancedFormView.vue?vue&type=script&lang=ts&"
import style0 from "./AdvancedFormView.vue?vue&type=style&index=0&id=bf2708cc&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports